let context: AudioContext | null = null;
let gainNode: GainNode | null = null;
let dingBuffer: AudioBuffer | null = null;
let tickBuffers: Record<string, AudioBuffer> = {};
let tickBuffersLoaded = false;
let noiseBuffer: AudioBuffer | null = null;

export async function setUpKeySound(key: string) {
  if (!window) return;
  if (tickBuffers[key]) return;
  context = new (window.AudioContext || (window as any).webkitAudioContext)();
  gainNode = context.createGain();
  gainNode.gain.value = 0.2;
  gainNode.connect(context.destination);

  await fetch(`./public/tt-key-${key}.wav`)
    .then(response => response.arrayBuffer())
    .then(arrayBuffer => context!.decodeAudioData(arrayBuffer))
    .then(audioBuffer => tickBuffers[key] = audioBuffer);
}

export async function setUpAudio() {
  if (!window) return;
  if (dingBuffer) return;
  context = new (window.AudioContext || (window as any).webkitAudioContext)();

  fetch("./public/tt-ding.wav")
    .then(response => response.arrayBuffer())
    .then(arrayBuffer => context!.decodeAudioData(arrayBuffer))
    .then(audioBuffer => dingBuffer = audioBuffer);

  await Promise.all([
    setUpKeySound("1"),
    setUpKeySound("2"),
    setUpKeySound("3"),
    setUpKeySound("4"),
    setUpKeySound("5"),
    setUpKeySound("6"),
    setUpKeySound("7"),
    setUpKeySound("8"),
    setUpKeySound("9"),
    setUpKeySound("10"),
    setUpKeySound("11"),
    setUpKeySound("12"),
    setUpKeySound("13"),
    setUpKeySound("14"),
    setUpKeySound("15"),
    setUpKeySound("16"),
    setUpKeySound("17"),
    setUpKeySound("18"),
    setUpKeySound("19"),
    setUpKeySound("20"),
    setUpKeySound("21"),
    setUpKeySound("22"),
    setUpKeySound("23"),
  ]);
  tickBuffersLoaded = true;

  await fetch("./public/tt-noise.wav")
    .then(response => response.arrayBuffer())
    .then(arrayBuffer => context!.decodeAudioData(arrayBuffer))
    .then(audioBuffer => noiseBuffer = audioBuffer);
}

let noiseSource: AudioBufferSourceNode | null = null;
export async function playTypewriterNoise() {
  if (!noiseBuffer) {
    console.error("Noise buffer not loaded");
    return;
  }
  if (context == null) {
    console.error("Audio context not set up");
    return;
  }
  noiseSource = context!.createBufferSource();
  noiseSource.buffer = noiseBuffer!;
  noiseSource.connect(gainNode!);
  noiseSource.loop = true;
  noiseSource.start();
}

export function stopTypewriterNoise() {
  if (noiseSource) {
    noiseSource.stop();
    noiseSource.disconnect();
    noiseSource = null;
  }
}

let countTicks = 23
let lastPlayedDing = 1;
let concurrentPlaying = 0;
export function playTypewriterKeySound(volume: "SILENT" | "NOISY", char: string) {
  if (volume == "SILENT" || concurrentPlaying > 5) {
    return;
  }
  if (char == "\x07") {
    playTypewriterDingSound(volume, true);
    return;
  }
  let thisDing = (lastPlayedDing + Math.floor(Math.random() * 5) + 1) % countTicks + 1;
  lastPlayedDing = thisDing;
  if (!tickBuffers[thisDing.toString()]) {
    console.error(`Tick buffer for ${thisDing} not loaded`);
    return;
  }

  const source = context!.createBufferSource();
  source.buffer = tickBuffers[thisDing.toString()];
  source.connect(gainNode!);
  concurrentPlaying++;
  source.start();
  source.addEventListener("ended", () => {
    concurrentPlaying--;
  });
}

export function playTypewriterDingSound(volume: "SILENT" | "NOISY", suppressKeySound = false) {
  if (volume == "SILENT" || concurrentPlaying > 5) {
    return;
  }
  if (!dingBuffer) {
    console.error("Ding buffer not loaded");
    return;
  }
  if (!suppressKeySound) { playTypewriterKeySound(volume, ".") };
  const source = context!.createBufferSource();
  source.buffer = dingBuffer!;
  source.connect(gainNode!);
  concurrentPlaying++;
  source.start();
  source.addEventListener("ended", () => {
    concurrentPlaying--;
  });
}
